// ------ plugin import ------- //
import React from 'react'
import Select from 'react-select'

const CreditReport = () => {
    const productType = [
        { value: 'option 1', label: 'Option 1' },
        { value: 'option 2', label: 'Option 2' },
        { value: 'option 3', label: 'Option 3' },
        { value: 'option 4', label: 'Option 4' },
        { value: 'option 5', label: 'Option 5' },
    ];
    return (
        <>
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="card card-flush border">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Credit Summary Report
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 0 details are available
                                </span>
                            </h3>
                            <div className="card-toolbar">
                                <Select 
                                    className='react-select-styled react-select-solid me-3' 
                                    classNamePrefix='react-select' 
                                    options={productType} 
                                    placeholder='Select month' 
                                    styles={{
                                        container: (base) => ({
                                            ...base,
                                            width: '220px',
                                        }),
                                    }}
                                />
                                <Select 
                                    className='react-select-styled react-select-solid me-3' 
                                    classNamePrefix='react-select' 
                                    options={productType} 
                                    placeholder='Select year' 
                                    styles={{
                                        container: (base) => ({
                                            ...base,
                                            width: '220px',
                                        }),
                                    }}
                                />
                                <button className="btn btn-dark me-2">
                                    Search
                                </button>
                                <button className="btn btn-dark">
                                    Export
                                </button>
                            </div>
                        </div>
                        <div className="card-body py-0">
                            <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th className="w-300px sorting">Date</th>
                                                <th className="w-250px sorting">Debit / Credit</th>
                                                <th className="w-250px sorting">Credit Activity </th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold">
                                            <tr className="">
                                                <td className="align-items-center">
                                                    <div className="d-flex flex-column">
                                                        <span>
                                                            <div className="fw-bold">
                                                                17 December 2024 at 13:02
                                                            </div>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="me-2">
                                                        <div className="badge badge-light-danger fw-bold mb-1">
                                                            Credit Used
                                                        </div>
                                                    </span>
                                                </td>
                                                <td>
                                                    11
                                                </td>
                                            </tr>
                                            <tr className="">
                                                <td className="align-items-center">
                                                    <div className="d-flex flex-column">
                                                        <span>
                                                            <div className="fw-bold">
                                                                17 December 2024 at 15:02
                                                            </div>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="me-2">
                                                        <div className="badge badge-light-success fw-bold mb-1">
                                                            Credit Added
                                                        </div>
                                                    </span>
                                                </td>
                                                <td>
                                                    5
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreditReport